module.exports = __webpack_public_path__ + "static/media/mastercard.aea781c5.svg";